import { render } from "./gif.vue?vue&type=template&id=dd88c406"
const script = {}
script.render = render

export default script